import type { NavItems } from '@ksyos/design-system';

export type NavigationGroup = {
    icon: NavItems['icon'];
    items: NavItems[];
    label: NavItems['label'];
};

export function groupNavigationItems({ items, icon, label }: NavigationGroup): NavItems | null {
    if (items.length === 0) {
        return null;
    }

    if (items.length === 1) {
        return {
            ...items[0],
            icon,
            label,
        };
    }

    return {
        icon,
        items: items,
        key: label.toLowerCase(),
        label,
        variant: 'button',
    };
}
